import { FAVORITE_CATEGORY } from '../../../constants';
import { useGamesStore } from '../../../store';
import { useCasinoSettings } from '../../useCasinoSettings';

export const useFavoritesCustomCategories = ({ casinoType, category }) => {
  const favorites = useGamesStore('favorites');
  const { favoritesRequestEntityName } = useCasinoSettings(casinoType);

  // favorites taken from other BE service which sends games ids (not launch ids)
  const favoriteCategoryGamesIds = favorites?.[favoritesRequestEntityName]?.ids;

  const isFavoriteCategory = category === FAVORITE_CATEGORY.id;

  return {
    favoriteCategoryGamesIds,
    isFavoriteCategory,
    isFavoritesLoaded: favorites?.[favoritesRequestEntityName]?.isLoaded,
    instantFavoritesPlexRequestPageSize:
      favoriteCategoryGamesIds?.length > 200
        ? 200
        : favoriteCategoryGamesIds?.length
  };
};
